import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class WebsiteDeepProfileAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteDeepProfile';


	aiReport(id) {
		let request = {
			url: [this.getAPIUrl(), id, 'ai-report'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new WebsiteDeepProfileAPI();
